import nenette1 from './../resources/nenette1.png'
import nenette2 from './../resources/nenette2.png'
import nenette3 from './../resources/nenette3.png'
import nenette4 from './../resources/nenette4.jpg'
import nenette5 from './../resources/nenette5.png'
import nenette6 from './../resources/nenette6.png'

import lake1 from './../resources/lake1.jpg'
import lake2 from './../resources/lake2.jpg'
import lake3 from './../resources/lake3.jpg'
import lake4 from './../resources/lake4.jpg'
import lake5 from './../resources/lake5.jpg'
import lake6 from './../resources/lake6.jpg'
import lake7 from './../resources/lake7.jpg'
import lake8 from './../resources/lake8.jpg'
import lake9 from './../resources/lake9.jpg'

import arch1 from './../resources/arch1.jpg'
import arch2 from './../resources/arch2.jpg'
import arch3 from './../resources/arch3.jpg'
import arch4 from './../resources/arch4.jpg'
import arch5 from './../resources/arch5.jpg'
import arch6 from './../resources/arch6.jpg'
import arch7 from './../resources/arch7.jpg'
import arch8 from './../resources/arch8.jpg'

import aif1 from './../resources/aif1.jpg'
import aif2 from './../resources/aif2.png'
import aif3 from './../resources/aif3.jpg'
import aif4 from './../resources/aif4.jpg'
import aif5 from './../resources/aif5.jpg'
import aif6 from './../resources/aif6.jpg'
import aif7 from './../resources/aif7.jpg'
import aif8 from './../resources/aif8.jpg'
import aif9 from './../resources/aif9.jpg'
import aif10 from './../resources/aif10.jpg'
import aif11 from './../resources/aif11.jpg'
import aif12 from './../resources/aif12.jpg'

import blindDeads1 from './../resources/blindDeads1.jpg'
import blindDeads2 from './../resources/blindDeads2.jpg'
import blindDeads3 from './../resources/blindDeads3.jpg'
import blindDeads4 from './../resources/blindDeads4.JPG'

import crocodiles1 from './../resources/crocodiles1.jpg'
import crocodiles2 from './../resources/crocodiles2.jpg'
import crocodiles3 from './../resources/crocodiles3.jpg'
import crocodiles4 from './../resources/crocodiles4.jpg'
import crocodiles5 from './../resources/crocodiles5.jpg'
import crocodiles6 from './../resources/crocodiles6.jpg'

import africanRhymes1 from './../resources/africanRhymes1.jpg'
import africanRhymes2 from './../resources/africanRhymes2.jpg'
import africanRhymes3 from './../resources/africanRhymes3.jpg'
import africanRhymes4 from './../resources/africanRhymes4.jpg'
import africanRhymes5 from './../resources/africanRhymes5.jpg'

import postIt1 from './../resources/postIt1.jpg'
import postIt2 from './../resources/postIt2.jpg'
import postIt3 from './../resources/postIt3.jpg'
import postIt4 from './../resources/postIt4.jpg'
import postIt5 from './../resources/postIt5.jpg'
import postIt6 from './../resources/postIt6.jpg'
import postIt7 from './../resources/postIt7.jpg'
import postIt8 from './../resources/postIt8.jpg'
import postIt9 from './../resources/postIt9.jpg'

import fatherOrArtist1 from './../resources/fatherOrArtist1.png'
import fatherOrArtist2 from './../resources/fatherOrArtist2.jpg'
import fatherOrArtist3 from './../resources/fatherOrArtist3.png'
import fatherOrArtist4 from './../resources/fatherOrArtist4.png'
import fatherOrArtist5 from './../resources/fatherOrArtist5.png'
import fatherOrArtist6 from './../resources/fatherOrArtist6.png'
import fatherOrArtist7 from './../resources/fatherOrArtist7.jpg'

import authouart1 from './../resources/authouart1.jpg'
import authouart2 from './../resources/authouart2.jpg'
import authouart3 from './../resources/authouart3.jpg'
import authouart4 from './../resources/authouart4.jpg'
import authouart5 from './../resources/authouart5.jpg'
import authouart6 from './../resources/authouart6.jpg'
import authouart7 from './../resources/authouart7.jpg'

import artRooms1 from './../resources/artRoom1.jpg'
import artRooms2 from './../resources/artRoom2.jpg'
import artRooms3 from './../resources/artRoom3.jpg'
import artRooms4 from './../resources/artRoom4.jpg'

import playTime1 from './../resources/playTime1.jpg'
import playTime2 from './../resources/playTime2.jpg'
import playTime3 from './../resources/playTime3.jpg'
import playTime4 from './../resources/playTime4.jpg'
import playTime5 from './../resources/playTime5.jpg'
import playTime6 from './../resources/playTime6.jpg'
import playTime7 from './../resources/playTime7.jpg'
import playTime8 from './../resources/playTime8.jpg'
import playTime9 from './../resources/playTime9.jpg'
import playTime10 from './../resources/playTime10.jpg'
import playTime11 from './../resources/playTime11.jpg'
import playTime12 from './../resources/playTime12.jpg'
import playTime13 from './../resources/playTime13.jpg'

import aragon1 from './../resources/aragon1.jpg'
import aragon2 from './../resources/aragon2.jpg'
import aragon3 from './../resources/aragon3.jpg'
import aragon4 from './../resources/aragon4.jpg'
import aragon5 from './../resources/aragon5.jpg'
import aragon6 from './../resources/aragon6.jpg'
import aragon7 from './../resources/aragon7.jpg'
import aragon8 from './../resources/aragon8.jpg'
import aragon9 from './../resources/aragon9.jpg'
import aragon10 from './../resources/aragon10.jpg'
import aragon11 from './../resources/aragon11.jpg'
import aragon12 from './../resources/aragon12.jpg'
import aragon13 from './../resources/aragon13.jpg'
import aragon14 from './../resources/aragon14.jpg'
import aragon15 from './../resources/aragon15.jpg'
import aragon16 from './../resources/aragon16.jpg'
import aragon17 from './../resources/aragon17.jpg'
import aragon18 from './../resources/aragon18.jpg'
import aragon19 from './../resources/aragon19.jpg'
import aragon20 from './../resources/aragon20.jpg'
import aragon21 from './../resources/aragon21.jpg'
import aragon22 from './../resources/aragon22.jpg'
import aragon23 from './../resources/aragon23.jpg'
import aragon24 from './../resources/aragon24.jpg'
import aragon25 from './../resources/aragon25.jpg'
import aragon26 from './../resources/aragon26.jpg'
import aragon27 from './../resources/aragon27.jpg'
import aragon28 from './../resources/aragon28.jpg'
import aragon29 from './../resources/aragon29.jpg'
import aragon30 from './../resources/aragon30.jpg'
import aragon31 from './../resources/aragon31.jpg'
import aragon32 from './../resources/aragon32.jpg'
import aragon33 from './../resources/aragon33.jpg'
import aragon34 from './../resources/aragon34.jpg'
import aragon35 from './../resources/aragon35.jpg'
import aragon36 from './../resources/aragon36.jpg'
import aragon37 from './../resources/aragon37.jpg'
import aragon38 from './../resources/aragon38.jpg'

import forests1 from './../resources/forests1.jpg'
import forests2 from './../resources/forests2.jpg'
import forests3 from './../resources/forests3.jpg'
import forests4 from './../resources/forests4.jpg'
import forests5 from './../resources/forests5.jpg'
import forests6 from './../resources/forests6.jpg'
import forests7 from './../resources/forests7.jpg'

import movies1 from './../resources/movies1.jpg'
import movies2 from './../resources/movies2.jpg'
import movies3 from './../resources/movies3.jpg'
import movies4 from './../resources/movies4.jpg'
import movies5 from './../resources/movies5.jpg'
import movies6 from './../resources/movies6.jpg'
import movies7 from './../resources/movies7.jpg'
import movies8 from './../resources/movies8.jpg'
import movies9 from './../resources/movies9.jpg'
import movies10 from './../resources/movies10.jpg'
import movies11 from './../resources/movies11.jpg'
import movies12 from './../resources/movies12.jpg'
import movies13 from './../resources/movies13.jpg'
import movies14 from './../resources/movies14.jpg'
import movies15 from './../resources/movies15.jpg'
import movies16 from './../resources/movies16.jpg'
import movies17 from './../resources/movies17.jpg'
import movies18 from './../resources/movies18.jpg'
import movies19 from './../resources/movies19.jpg'
import movies20 from './../resources/movies20.jpg'
import movies21 from './../resources/movies21.jpg'
import movies22 from './../resources/movies22.jpg'
import movies23 from './../resources/movies23.jpg'
import movies24 from './../resources/movies24.jpg'
import movies25 from './../resources/movies25.jpg'
import movies26 from './../resources/movies26.jpg'
import movies27 from './../resources/movies27.jpg'
import movies28 from './../resources/movies28.jpg'
import movies29 from './../resources/movies29.jpg'
import movies30 from './../resources/movies30.jpg'
import movies31 from './../resources/movies31.jpg'
import movies32 from './../resources/movies32.jpg'
import movies33 from './../resources/movies33.jpg'
import movies34 from './../resources/movies34.jpg'
import movies35 from './../resources/movies35.jpg'
import movies36 from './../resources/movies36.jpg'
import movies37 from './../resources/movies37.jpg'
import movies38 from './../resources/movies38.jpg'
import movies39 from './../resources/movies39.jpg'
import movies40 from './../resources/movies40.jpg'
import movies41 from './../resources/movies41.jpg'
import movies42 from './../resources/movies42.jpg'
import movies43 from './../resources/movies43.jpg'
import movies44 from './../resources/movies44.jpg'


const nenetteImages = [
    {index: 1, src: nenette1, title: 'nenette1', description: ''},
    {index: 2, src: nenette2, title: 'nenette2', description: ''},
    {index: 3, src: nenette3, title: 'nenette3', description: ''},
    {index: 4, src: nenette4, title: 'nenette4', description: ''},
    {index: 5, src: nenette5, title: 'nenette5', description: ''},
    {index: 6, src: nenette6, title: 'nenette6', description: ''},
];

const lakeImages = [
    {index: 1, src: lake1, title: 'lake1', description: ''},
    {index: 2, src: lake4, title: 'lake4', description: ''},
    {index: 3, src: lake5, title: 'lake5', description: ''},
    {index: 4, src: lake6, title: 'lake6', description: ''},
    {index: 5, src: lake8, title: 'lake8', description: ''},
    {index: 6, src: lake3, title: 'lake3', description: ''},
    {index: 7, src: lake9, title: 'lake9', description: ''},
    {index: 8, src: lake2, title: 'lake2', description: ''},
    {index: 9, src: lake7, title: 'lake7', description: ''},
]

const archImages = [
    {
        index: 1,
        src: arch7,
        title: 'arch7',
        description: '',
        url: 'https://www.youtube.com/watch?v=SRL4jELEY88'
    },
    {index: 2, src: arch1, title: 'arch1', description: ''},
    {index: 3, src: arch2, title: 'arch2', description: ''},
    {index: 4, src: arch3, title: 'arch3', description: ''},
    {index: 5, src: arch4, title: 'arch4', description: ''},
    {index: 6, src: arch5, title: 'arch5', description: ''},
    {index: 7, src: arch6, title: 'arch6', description: ''},
    {
        index: 8,
        src: arch8,
        title: 'arch8',
        description: '',
        url: 'https://www.youtube.com/watch?v=p2woFcoADys'
    },
]

const aifImages = [
    {index: 1, src: aif1, title: 'aif1', description: ''},
    {index: 2, src: aif2, title: 'aif2', description: ''},
    {index: 3, src: aif3, title: 'aif3', description: ''},
    {index: 4, src: aif4, title: 'aif4', description: ''},
    {index: 5, src: aif5, title: 'aif5', description: ''},
    {index: 6, src: aif6, title: 'aif6', description: ''},
    {index: 7, src: aif7, title: 'aif7', description: ''},
    {index: 8, src: aif8, title: 'aif8', description: ''},
    {index: 9, src: aif9, title: 'aif9', description: ''},
    {index: 10, src: aif10, title: 'aif10', description: ''},
    {index: 11, src: aif11, title: 'aif11', description: ''},
    {index: 12, src: aif12, title: 'aif12', description: ''},
]

const blindDeadsImages = [
    {index: 1, src: blindDeads2, title: 'blindDeads2', description: ''},
    {index: 2, src: blindDeads3, title: 'blindDeads3', description: ''},
    {
        index: 3,
        src: blindDeads4,
        title: 'blindDeads4',
        description: '',
        url: 'https://www.youtube.com/watch?v=kcTKkJz5H-o'
    },
    {index: 4, src: blindDeads1, title: 'blindDeads1', description: ''},
];

const crocodilesImages = [
    {index: 1, src: crocodiles1, title: 'crocodiles1', description: ''},
    {index: 2, src: crocodiles2, title: 'crocodiles2', description: ''},
    {index: 3, src: crocodiles3, title: 'crocodiles3', description: ''},
    {index: 4, src: crocodiles4, title: 'crocodiles4', description: ''},
    {index: 5, src: crocodiles5, title: 'crocodiles5', description: ''},
    {index: 6, src: crocodiles6, title: 'crocodiles6', description: ''},
];

const africanRhymesImages = [
    {
        index: 1,
        src: africanRhymes2,
        title: 'africanRhymes2',
        description: '',
        url: 'https://www.youtube.com/watch?v=wLZfh7eSPVY'
    },
    {
        index: 2,
        src: africanRhymes3,
        title: 'africanRhymes3',
        description: '',
        url: 'https://www.youtube.com/watch?v=Fm-nqlO98tg'
    },
    {
        index: 3,
        src: africanRhymes4,
        title: 'africanRhymes4',
        description: '',
        url: 'https://www.youtube.com/watch?v=PsQqYLw9Bt8'
    },
    {
        index: 4,
        src: africanRhymes5,
        title: 'africanRhymes5',
        description: '',
        url: 'https://www.youtube.com/watch?v=NgmywN8GTic'
    },
    {
        index: 5,
        src: africanRhymes1,
        title: 'africanRhymes1',
        description: '',
        url: 'https://www.youtube.com/watch?v=lq8bH9YbftU'
    },
]

const worryBirdsImages = [
    {index: 1, src: null, title: 'worryBirds', description: '', url: 'https://www.youtube.com/watch?v=uZyws-M6d5s'},
]

const agnesMelodyImages = [
    {index: 1, src: null, title: 'agnesMelody', description: '', url: 'https://vimeo.com/172420408'},
]

const europeForRealImages = [
    {index: 1, src: null, title: 'europeForReal', description: '', url: 'https://www.youtube.com/watch?v=eVNfFt_cssk'},
]

const theHubImages = [
    {index: 1, src: null, title: 'theHub', description: '', url: 'https://www.youtube.com/watch?v=n6J_AQEbFcM'},
]

const postItImages = [
    {index: 1, src: postIt2, title: 'postIt2', description: '', url: 'https://vimeo.com/172425375'},
    {index: 2, src: postIt3, title: 'postIt3', description: ''},
    {index: 3, src: postIt4, title: 'postIt4', description: ''},
    {index: 4, src: postIt5, title: 'postIt5', description: ''},
    {index: 5, src: postIt6, title: 'postIt6', description: ''},
    {index: 6, src: postIt7, title: 'postIt7', description: ''},
    {index: 7, src: postIt8, title: 'postIt8', description: ''},
    {index: 8, src: postIt9, title: 'postIt9', description: ''},
    {index: 9, src: postIt1, title: 'postIt1', description: '', url: 'https://vimeo.com/188803957'},
]

const mediumsImages = [
    {index: 1, src: null, title: 'mediums', description: '', url: 'https://vimeo.com/493718474'},
]

const artRoomsImages = [
    {index: 1, src: artRooms1, title: 'artRooms1', description: '', url: 'https://youtu.be/Ru-NMTSj_Ec'},
    {index: 2, src: artRooms2, title: 'artRooms2', description: '', url: 'https://youtu.be/NvN_kvpMV18'},
    {index: 3, src: artRooms3, title: 'artRooms3', description: '', url: 'https://www.youtube.com/watch?v=ZX_IqKPT8LU'},
    {index: 4, src: artRooms4, title: 'artRooms4', description: '', url: 'https://www.youtube.com/watch?v=kGWT4pEnJtk'},
]

const fatherOrArtistImages = [
    {index: 1, src: fatherOrArtist1, title: 'fatherOrArtist1', description: ''},
    {index: 2, src: fatherOrArtist2, title: 'fatherOrArtist2', description: ''},
    {index: 3, src: fatherOrArtist3, title: 'fatherOrArtist3', description: ''},
    {index: 4, src: fatherOrArtist4, title: 'fatherOrArtist4', description: ''},
    {index: 5, src: fatherOrArtist5, title: 'fatherOrArtist5', description: ''},
    {index: 6, src: fatherOrArtist6, title: 'fatherOrArtist6', description: ''},
    {index: 7, src: fatherOrArtist7, title: 'fatherOrArtist7', description: ''},
]

const authouartImages = [
    {index: 1, src: authouart7, title: 'authouart7', description: '', url: 'https://vimeo.com/872501120'},
    {index: 2, src: authouart1, title: 'authouart1', description: '', url: 'https://vimeo.com/99809157'},
    {index: 3, src: authouart2, title: 'authouart2', description: '', url: 'https://youtu.be/4kAX5sqnWHQ'},
    {index: 4, src: authouart3, title: 'authouart3', description: '', url: 'https://youtu.be/S1gi-lCBWKs'},
    {index: 5, src: authouart4, title: 'authouart4', description: '', url: 'https://youtu.be/xzoP_nwLNpo'},
    {index: 6, src: authouart5, title: 'authouart5', description: '', url: 'https://youtu.be/UWm51P_o6bc'},
    {index: 7, src: authouart6, title: 'authouart6', description: '', url: 'https://youtu.be/nt22sqBBEqA'},
]

const playTimeImages = [
    {index: 1, src: playTime1, title: 'playTime1', description: ''},
    {index: 2, src: playTime2, title: 'playTime2', description: ''},
    {index: 3, src: playTime3, title: 'playTime3', description: ''},
    {index: 4, src: playTime4, title: 'playTime4', description: ''},
    {index: 5, src: playTime5, title: 'playTime5', description: ''},
    {index: 6, src: playTime6, title: 'playTime6', description: ''},
    {index: 7, src: playTime7, title: 'playTime7', description: ''},
    {index: 8, src: playTime8, title: 'playTime8', description: ''},
    {index: 9, src: playTime9, title: 'playTime9', description: ''},
    {index: 10, src: playTime10, title: 'playTime10', description: ''},
    {index: 11, src: playTime11, title: 'playTime11', description: ''},
    {index: 12, src: playTime12, title: 'playTime12', description: ''},
    {index: 13, src: playTime13, title: 'playTime13', description: ''},
];

const aragonImages = [
    {index: 1, src: aragon1, title: 'aragon1', description: ''},
    {index: 2, src: aragon2, title: 'aragon2 ', description: ''},
    {index: 3, src: aragon3, title: 'aragon3 ', description: ''},
    {index: 4, src: aragon4, title: 'aragon4 ', description: ''},
    {index: 5, src: aragon5, title: 'aragon5 ', description: ''},
    {index: 6, src: aragon6, title: 'aragon6 ', description: ''},
    {index: 7, src: aragon7, title: 'aragon7 ', description: ''},
    {index: 8, src: aragon8, title: 'aragon8 ', description: ''},
    {index: 9, src: aragon9, title: 'aragon9 ', description: ''},
    {index: 10, src: aragon10, title: 'aragon10', description: ''},
    {index: 11, src: aragon11, title: 'aragon11', description: ''},
    {index: 12, src: aragon12, title: 'aragon12', description: ''},
    {index: 13, src: aragon13, title: 'aragon13', description: ''},
    {index: 14, src: aragon14, title: 'aragon14', description: ''},
    {index: 15, src: aragon15, title: 'aragon15', description: ''},
    {index: 16, src: aragon16, title: 'aragon16', description: ''},
    {index: 17, src: aragon17, title: 'aragon17', description: ''},
    {index: 18, src: aragon18, title: 'aragon18', description: ''},
    {index: 19, src: aragon19, title: 'aragon19', description: ''},
    {index: 20, src: aragon20, title: 'aragon20', description: ''},
    {index: 21, src: aragon21, title: 'aragon21', description: ''},
    {index: 22, src: aragon22, title: 'aragon22', description: ''},
    {index: 23, src: aragon23, title: 'aragon23', description: ''},
    {index: 24, src: aragon24, title: 'aragon24', description: ''},
    {index: 25, src: aragon25, title: 'aragon25', description: ''},
    {index: 26, src: aragon26, title: 'aragon26', description: ''},
    {index: 27, src: aragon27, title: 'aragon27', description: ''},
    {index: 28, src: aragon28, title: 'aragon28', description: ''},
    {index: 29, src: aragon29, title: 'aragon29', description: ''},
    {index: 30, src: aragon30, title: 'aragon30', description: ''},
    {index: 31, src: aragon31, title: 'aragon31', description: ''},
    {index: 32, src: aragon32, title: 'aragon32', description: ''},
    {index: 33, src: aragon33, title: 'aragon33', description: ''},
    {index: 34, src: aragon34, title: 'aragon34', description: ''},
    {index: 35, src: aragon35, title: 'aragon35', description: ''},
    {index: 36, src: aragon36, title: 'aragon36', description: ''},
    {index: 37, src: aragon37, title: 'aragon37', description: ''},
    {index: 38, src: aragon38, title: 'aragon38', description: ''},
];

const forestsImages = [
    {index: 1, src: forests1, title: 'forests1', description: ''},
    {index: 2, src: forests2, title: 'forests2', description: ''},
    {index: 3, src: forests3, title: 'forests3', description: ''},
    {index: 4, src: forests4, title: 'forests4', description: ''},
    {index: 5, src: forests5, title: 'forests5', description: ''},
    {index: 6, src: forests6, title: 'forests6', description: ''},
    {index: 7, src: forests7, title: 'forests7', description: ''},
]

const moviesImages = [
    {index: 1, src: movies1, title: 'movies1', description: ''},
    {index: 2, src: movies2, title: 'movies2', description: ''},
    {index: 3, src: movies3, title: 'movies3', description: ''},
    {index: 4, src: movies4, title: 'movies4', description: ''},
    {index: 5, src: movies5, title: 'movies5', description: ''},
    {index: 6, src: movies6, title: 'movies6', description: ''},
    {index: 7, src: movies7, title: 'movies7', description: ''},
    {index: 8, src: movies8, title: 'movies8', description: ''},
    {index: 9, src: movies9, title: 'movies9', description: ''},
    {index: 10, src: movies10, title: 'movies10', description: ''},
    {index: 11, src: movies11, title: 'movies11', description: ''},
    {index: 12, src: movies12, title: 'movies12', description: ''},
    {index: 13, src: movies13, title: 'movies13', description: ''},
    {index: 14, src: movies14, title: 'movies14', description: ''},
    {index: 15, src: movies15, title: 'movies15', description: ''},
    {index: 16, src: movies16, title: 'movies16', description: ''},
    {index: 17, src: movies17, title: 'movies17', description: ''},
    {index: 18, src: movies18, title: 'movies18', description: ''},
    {index: 19, src: movies19, title: 'movies19', description: ''},
    {index: 20, src: movies20, title: 'movies20', description: ''},
    {index: 21, src: movies21, title: 'movies21', description: ''},
    {index: 22, src: movies22, title: 'movies22', description: ''},
    {index: 23, src: movies23, title: 'movies23', description: ''},
    {index: 24, src: movies24, title: 'movies24', description: ''},
    {index: 25, src: movies25, title: 'movies25', description: ''},
    {index: 26, src: movies26, title: 'movies26', description: ''},
    {index: 27, src: movies27, title: 'movies27', description: ''},
    {index: 28, src: movies28, title: 'movies28', description: ''},
    {index: 29, src: movies29, title: 'movies29', description: ''},
    {index: 30, src: movies30, title: 'movies30', description: ''},
    {index: 31, src: movies31, title: 'movies31', description: ''},
    {index: 32, src: movies32, title: 'movies32', description: ''},
    {index: 33, src: movies33, title: 'movies33', description: ''},
    {index: 34, src: movies34, title: 'movies34', description: ''},
    {index: 35, src: movies35, title: 'movies35', description: ''},
    {index: 36, src: movies36, title: 'movies36', description: ''},
    {index: 37, src: movies37, title: 'movies37', description: ''},
    {index: 38, src: movies38, title: 'movies38', description: ''},
    {index: 39, src: movies39, title: 'movies39', description: ''},
    {index: 40, src: movies40, title: 'movies40', description: ''},
    {index: 41, src: movies41, title: 'movies41', description: ''},
    {index: 42, src: movies42, title: 'movies42', description: ''},
    {index: 43, src: movies43, title: 'movies43', description: ''},
    {index: 44, src: movies44, title: 'movies44', description: ''},
]

const imageProvider =
    (project) => {
        switch (project) {
            case 'nenette':
                return nenetteImages
            case 'lake' :
                return lakeImages
            case 'arch' :
                return archImages
            case 'aif' :
                return aifImages
            case 'blindDeads' :
                return blindDeadsImages
            case 'crocodiles' :
                return crocodilesImages
            case 'africanRhymes' :
                return africanRhymesImages
            case 'worryBirds' :
                return worryBirdsImages
            case 'agnesMelody' :
                return agnesMelodyImages
            case 'europeForReal' :
                return europeForRealImages
            case 'postIt' :
                return postItImages
            case 'theHub' :
                return theHubImages
            case 'mediums' :
                return mediumsImages
            case 'artRooms' :
                return artRoomsImages
            case 'fatherOrArtist' :   
                return fatherOrArtistImages 
            case 'authouart' :
                return authouartImages
            case 'playTime' :
                return playTimeImages
            case 'aragon' :
                return aragonImages
            case 'forests' :
                return forestsImages
            case 'movies' :
                return moviesImages
            default :
                return null
        }
    }

export default imageProvider
